export default __webpack_public_path__ + "static/media/initiate-illustration.ee682382.svg";